<section class="therapy-plan-add-exercises-page">
  <div class="row g-3">
    <div class="col-12">
      <div class="sana-card mb-3">
        <div class="sana-card-header">
          <a
            class="back-hint"
            role="link"
            [routerLink]="['..']"
            tabindex="0">
            <i class="pi pi-chevron-left"></i> Zurück zum Therapieplan
          </a>
        </div>

        @if (isClientLoaded() && isExerciseListLoaded()) {
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        } @else {
          <sana-tp-sekeleton-loading></sana-tp-sekeleton-loading>
        }
      </div>
    </div>
  </div>
</section>


<ng-template #content>
  <div
    class="sana-card-header sticky-header"
    [ngClass]="{'scroll-padding': hasScrollPadding()}">

    {{ selectedJointNames() }}: Übungen für {{ selectedClient()!.fullNameWithTitle }}

    <div class="row justify-content-between gx-3 mt-2">
      <div class="col">
        <form [formGroup]="searchForm">
          <input
            pInputText
            id="searchText"
            [formControl]="searchForm.controls.searchText"
            [fluid]="true"
            [placeholder]="'Suchen Sie nach Übungen'" />
        </form>
      </div>

      <div class="col-auto">
        <p-overlay-badge
          [value]="selectedExerciseList()!.length"
          severity="contrast">

          <div>
            <p-button
              severity="primary"
              [label]="isMobile() ? '' : 'Ausgewählte Übungen'"
              icon="pi pi-shopping-cart"
              [badge]="selectedExerciseList()!.length.toString()"
              [disabled]="selectedExerciseList()!.length === 0"
              (click)="openTherapyPlanExerciseConfirmationDialog()"
              [fluid]="true" />
          </div>
        </p-overlay-badge>
      </div>
    </div>
  </div>

  <div
    class="sana-card-header sticky-header"
    style="top: 92px"
    [ngClass]="{'scroll-padding': hasScrollPadding() && !isMobile(), 'sticky-header': !isMobile(), 'top-92': !isMobile()}">
    <div class="row gx-3 gy-2">
      <div class="col-auto">
        <p-tag
          [icon]="isActivityFilterAdded(ExerciseActivityTypeEnum.Active) ? 'pi pi-filter-fill' : 'pi pi-filter'"
          [severity]="isActivityFilterAdded(ExerciseActivityTypeEnum.Active) ? 'contrast' : 'secondary'"
          value="Aktive Übungen"
          (click)="activityTypeFilterClicked(ExerciseActivityTypeEnum.Active)" />
      </div>

      <div class="col-auto">
        <p-tag
          [icon]="isActivityFilterAdded(ExerciseActivityTypeEnum.Passive) ? 'pi pi-filter-fill' : 'pi pi-filter'"
          [severity]="isActivityFilterAdded(ExerciseActivityTypeEnum.Passive) ? 'contrast' : 'secondary'"
          value="Passive Übungen"
          (click)="activityTypeFilterClicked(ExerciseActivityTypeEnum.Passive)" />
      </div>

      <div class="col-auto">
        <p-tag
          [icon]="isActivityFilterAdded(ExerciseActivityTypeEnum.Assistive) ? 'pi pi-filter-fill' : 'pi pi-filter'"
          [severity]="isActivityFilterAdded(ExerciseActivityTypeEnum.Assistive) ? 'contrast' : 'secondary'"
          value="Aktiv assistive Übungen"
          (click)="activityTypeFilterClicked(ExerciseActivityTypeEnum.Assistive)" />
      </div>

      <!--  @if (isForNewSectionWithExistingPlan()) {
          <div class="col-auto">
            <p-tag
              [icon]="isPreviousSectionExerciseFilterSelected ? 'pi pi-filter-fill' : 'pi pi-filter'"
              [severity]="isPreviousSectionExerciseFilterSelected ? 'contrast' : 'secondary'"
              value="Übungen aus vorherigem Abschnitt"
              (click)="previousSectionExerciseFilterClicked()" />
          </div>
        }-->

      <div class="col-12 mt-3">
        <div class="row gx-3 gy-3">
          <div class="col-auto">
            <p-button
              [label]="'Alle Übungen zum Therapieplan hinzufügen (' + filteredExerciseList()!.length + ')'"
              (onClick)="addAllExerciseToPlan(filteredExerciseList())"
              severity="secondary"
              icon="pi pi-plus"
              size="small"></p-button>
          </div>

          @if (isPreviousTherapyPlanApplied()) {
            <div class="col-auto">
              <p-button
                [label]="'Übungen aus vorherigem Plan hinzufügen (' + previousExercisesApplicableList()!.length + ')'"
                (onClick)="addPreviousExercisesToPlan()"
                severity="secondary"
                icon="pi pi-plus"
                size="small"></p-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="sana-card-body">


    <div class="mt-4">
      <sana-tp-exercise-template-list
        [allTemplateExerciseList]="filteredExerciseList"
        [selectedTemplateExerciseList]="selectedExerciseList"
        [clientId]="selectedClient().id!"
        (addExercise)="addExerciseToPlan($event)"
        (removeExercise)="removeExerciseFromPlan($event)"
      ></sana-tp-exercise-template-list>
    </div>
  </div>
</ng-template>
